import { downloadCsv } from '../../../lib/csv';
interface Props { rows: Array<Record<string, unknown>>; filename: string }
export function DownloadMenu({ rows, filename }: Props) {
  const copyJson = async () => { if (typeof navigator === 'undefined' || !navigator.clipboard) return; await navigator.clipboard.writeText(JSON.stringify(rows, null, 2)); };
  return <div className="flex gap-2 text-sm"><button className="rounded border px-3 py-2" onClick={() => downloadCsv(`${filename}.csv`, rows)}>Descargar CSV</button><button className="rounded border px-3 py-2" onClick={copyJson}>Copiar JSON</button></div>;
}
